import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'aid-avatar',
  template: `
    <div class="flex">
      @if (image) {
        <img
          class="avatar--border-radius"
          src="{{ image }}"
          [style.height]="sizeAsString"
          [style.width]="sizeAsString"
          [style.font-size]="sizeAsString"
          alt=" "
        />
      }
      @if (!image && !name) {
        <mat-icon
          class="avatar--border-radius avatar--color"
          svgIcon="account"
          [style.height]="sizeAsString"
          [style.width]="sizeAsString"
          [style.font-size]="sizeAsString"
        ></mat-icon>
      }

      @if (name && !image) {
        <div
          [style.height]="sizeAsString"
          [style.width]="sizeAsString"
          [style.font-size]="fontSizeAsString"
          class="mat-subtitle-2 name aid-layout-row aid-layout-align-center-center"
        >
          <div>{{ name | initials }}</div>
        </div>
      }
    </div>
  `,
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AvatarComponent implements OnInit {
  @Input() image?: string;
  @Input() size = 32;
  @Input() name?: string;

  constructor() {}

  ngOnInit() {}

  get sizeAsString() {
    return `${this.size}px`;
  }

  get fontSizeAsString() {
    if (this.size > 60) {
      return `32px`;
    }
    return `14px`;
  }
}
